import { create } from "../../../common/utils/zustand_state_manager";
import { IEntregaObrasService } from "../../../features/entregaObras/data/services/entrega_obras_service";
import { EntregaObrasService } from "../../../features/entregaObras/data/services/entrega_obras_service_impl";

/**
 * useEntregaObrasServices
 */

type State = {
  entregaObrasService: IEntregaObrasService,
};

export const useEntregaObrasServices = create<State>((set, get) => ({
  entregaObrasService: new EntregaObrasService(),
}));